module.exports = __webpack_public_path__ + "img/停车场.5a5d0fe9.png";